import { createStore, createEffect, createEvent, combine } from 'effector';
import { fetchAndActivate, getAll, getValue, Value } from 'firebase/remote-config';
import { remoteConfig } from '../../../firebase.config';

const ValueEnum = {
  Boolean: 'boolean',
  Number: 'number',
  JSON: 'json',
  String: 'string',
} as const;
export type ValueEnum = (typeof ValueEnum)[keyof typeof ValueEnum];

const getRemoteConfigEffect = createEffect(async () => {
  await fetchAndActivate(remoteConfig);
  return getAll(remoteConfig);
});
function getValueEvent(key: string, type: typeof ValueEnum.String): string;
function getValueEvent(key: string, type: typeof ValueEnum.Number): number;
function getValueEvent(key: string, type: typeof ValueEnum.Boolean): boolean;
function getValueEvent<T = {}>(key: string, type: typeof ValueEnum.JSON): T;
function getValueEvent(key: string): string;
function getValueEvent(key: string, type?: ValueEnum) {
  const value: Value = getValue(remoteConfig, key);

  switch (type) {
    case ValueEnum.String:
      return value.asString();
    case ValueEnum.Number:
      return value.asNumber();
    case ValueEnum.Boolean:
      return value.asBoolean();
    case ValueEnum.JSON:
      return JSON.parse(value.asString() || '{}');
    default:
      return value.asString();
  }
}

const clearEvent = createEvent();

const $dataStore = createStore<Record<string, Value>>({})
  .on(getRemoteConfigEffect.done, (current, data) => data.result || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getRemoteConfigEffect.pending, (_, data) => data)
  .on(getRemoteConfigEffect.fail, () => false)
  .on(getRemoteConfigEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getRemoteConfigEffect, () => null)
  // .on(getRemoteConfigEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getRemoteConfigEffect.fail, () => 'Something went wrong while fetching Remote Config. Please try again.')
  .on(getRemoteConfigEffect.done, () => null)
  .reset(clearEvent);

export const $remoteConfigStore = {
  events: {
    getRemoteConfig: getRemoteConfigEffect,
    getValue: getValueEvent,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
